//header active 判斷
$(".header-navigation li, .header_navigation_info li").each(function () {
    let link = $(this).children("a");
    let type = $(this).data("type")
    let LinkURl = link.data("href") ?  link.data("href") : link.attr("href");
    if (location_pathname[location_pathname.length-1].indexOf(LinkURl) >-1) {
        $(this).addClass("active")
    } else if (location_pathname[location_pathname.length-1] === "") {
        $(".header-navigation li:nth-child(1)").addClass("active")
    } else if (location_pathname[location_pathname.length-1].indexOf("info.html")>-1) {
        if (type) {
            let filter_type = urlParams.get('type');
            if (filter_type == type) {
                $(this).addClass("active")

            }
        }
    }
})